// Auto-generated from tames.txt - do not edit manually
// Run: node scripts/parseTames.js

export const tames = [
  {
    name: 'huge spider',
    area: 'Abbadon',
    levelMin: 135,
    levelMax: 135,
    tameMin: 607,
    tameMax: 607,
  },
  {
    name: 'ancient giraffe',
    area: 'Abbadon',
    levelMin: 130,
    levelMax: 130,
    tameMin: 520,
    tameMax: 585,
  },
  {
    name: 'guardian tomcat',
    area: 'Kittay',
    levelMin: 120,
    levelMax: 120,
    tameMin: 480,
    tameMax: 540,
  },
  {
    name: 'giant mantis',
    area: 'Ensi',
    levelMin: 95,
    levelMax: 99,
    tameMin: 475,
    tameMax: 495,
  },
  {
    name: 'lesser guardian tomcat',
    area: 'Kittay',
    levelMin: 110,
    levelMax: 110,
    tameMin: 440,
    tameMax: 495,
  },
  {
    name: 'jackalope',
    area: 'Ensi',
    levelMin: 95,
    levelMax: 97,
    tameMin: 475,
    tameMax: 485,
  },
  {
    name: 'coyote',
    area: 'Ensi',
    levelMin: 90,
    levelMax: 95,
    tameMin: 450,
    tameMax: 475,
  },
  {
    name: 'big-horned sheep',
    area: 'Ensi',
    levelMin: 90,
    levelMax: 94,
    tameMin: 450,
    tameMax: 470,
  },
  {
    name: 'bison',
    area: 'Ensi',
    levelMin: 93,
    levelMax: 93,
    tameMin: 465,
    tameMax: 465,
  },
  {
    name: 'rhinoceros',
    area: 'Ensi',
    levelMin: 91,
    levelMax: 93,
    tameMin: 455,
    tameMax: 465,
  },
  {
    name: 'arctic treant',
    area: 'Aerioth II',
    levelMin: 90,
    levelMax: 92,
    tameMin: 450,
    tameMax: 460,
  },
  {
    name: 'hissing cockroach',
    area: 'Kittay',
    levelMin: 100,
    levelMax: 100,
    tameMin: 400,
    tameMax: 450,
  },
  {
    name: 'fire ant guardian',
    area: 'Ensi',
    levelMin: 97,
    levelMax: 99,
    tameMin: 388,
    tameMax: 396,
  },
  {
    name: 'grizzly bear',
    area: 'Liku',
    levelMin: 65,
    levelMax: 65,
    tameMin: 390,
    tameMax: 390,
  },
  {
    name: 'fire ant soldier',
    area: 'Ensi',
    levelMin: 95,
    levelMax: 97,
    tameMin: 380,
    tameMax: 388,
  },
  {
    name: 'black bear',
    area: 'Ensi',
    levelMin: 95,
    levelMax: 97,
    tameMin: 380,
    tameMax: 388,
  },
  {
    name: 'fire ant worker',
    area: 'Ensi',
    levelMin: 92,
    levelMax: 94,
    tameMin: 368,
    tameMax: 376,
  },
  {
    name: 'fire ant drone',
    area: 'Ensi',
    levelMin: 92,
    levelMax: 94,
    tameMin: 368,
    tameMax: 376,
  },
  {
    name: 'hawk',
    area: 'Shanadan',
    levelMin: 65,
    levelMax: 74,
    tameMin: 325,
    tameMax: 370,
  },
  {
    name: 'hawk',
    area: 'Ensi',
    levelMin: 92,
    levelMax: 92,
    tameMin: 368,
    tameMax: 368,
  },
  {
    name: 'snake',
    area: 'Ensi',
    levelMin: 90,
    levelMax: 92,
    tameMin: 360,
    tameMax: 368,
  },
  {
    name: 'bear cub',
    area: 'Ensi',
    levelMin: 90,
    levelMax: 92,
    tameMin: 360,
    tameMax: 368,
  },
  {
    name: 'spider',
    area: 'Ensi',
    levelMin: 90,
    levelMax: 92,
    tameMin: 360,
    tameMax: 368,
  },
  {
    name: 'jaguar',
    area: 'Ensi',
    levelMin: 90,
    levelMax: 92,
    tameMin: 360,
    tameMax: 368,
  },
  {
    name: 'badger',
    area: 'Ensi',
    levelMin: 90,
    levelMax: 90,
    tameMin: 360,
    tameMax: 360,
  },
  {
    name: 'jaguar cub',
    area: 'Ensi',
    levelMin: 90,
    levelMax: 90,
    tameMin: 360,
    tameMax: 360,
  },
  {
    name: 'buffalo',
    area: 'Charanth',
    levelMin: 90,
    levelMax: 90,
    tameMin: 360,
    tameMax: 360,
  },
  {
    name: 'addax',
    area: 'Mjharr',
    levelMin: 70,
    levelMax: 70,
    tameMin: 350,
    tameMax: 350,
  },
  {
    name: 'vampire bat',
    area: 'Shanadan',
    levelMin: 60,
    levelMax: 70,
    tameMin: 300,
    tameMax: 350,
  },
  {
    name: 'shadowhound',
    area: 'Charanth',
    levelMin: 85,
    levelMax: 85,
    tameMin: 340,
    tameMax: 340,
  },
  {
    name: 'spinyback toad',
    area: 'Ottograd',
    levelMin: 65,
    levelMax: 65,
    tameMin: 325,
    tameMax: 325,
  },
  {
    name: 'frost drake',
    area: 'Aerioth II',
    levelMin: 60,
    levelMax: 65,
    tameMin: 300,
    tameMax: 325,
  },
  {
    name: 'wild ox',
    area: 'Ottograd',
    levelMin: 60,
    levelMax: 60,
    tameMin: 300,
    tameMax: 300,
  },
  {
    name: 'shrew',
    area: 'Mjharr',
    levelMin: 70,
    levelMax: 70,
    tameMin: 280,
    tameMax: 280,
  },
  {
    name: 'woodchuck',
    area: 'Ottograd',
    levelMin: 55,
    levelMax: 55,
    tameMin: 275,
    tameMax: 275,
  },
  {
    name: 'dire wolf',
    area: 'Aerioth II',
    levelMin: 55,
    levelMax: 55,
    tameMin: 275,
    tameMax: 275,
  },
  {
    name: 'gazelle',
    area: 'Liku',
    levelMin: 53,
    levelMax: 65,
    tameMin: 212,
    tameMax: 260,
  },
  {
    name: 'coyote',
    area: 'Liku',
    levelMin: 58,
    levelMax: 65,
    tameMin: 232,
    tameMax: 260,
  },
  {
    name: 'lemming',
    area: 'Ottograd',
    levelMin: 50,
    levelMax: 50,
    tameMin: 250,
    tameMax: 250,
  },
  {
    name: 'panther',
    area: 'Korlis',
    levelMin: 15,
    levelMax: 24,
    tameMin: 150,
    tameMax: 240,
  },
  {
    name: 'snow bear',
    area: 'Hiemelia',
    levelMin: 45,
    levelMax: 45,
    tameMin: 225,
    tameMax: 225,
  },
  {
    name: 'mountain elk',
    area: 'Aerioth',
    levelMin: 45,
    levelMax: 45,
    tameMin: 225,
    tameMax: 225,
  },
  {
    name: 'snow lynx',
    area: 'Aerioth',
    levelMin: 45,
    levelMax: 45,
    tameMin: 225,
    tameMax: 225,
  },
  {
    name: 'fire ant',
    area: 'Ensi',
    levelMin: 50,
    levelMax: 50,
    tameMin: 200,
    tameMax: 200,
  },
  {
    name: 'snow fox',
    area: 'Aerioth',
    levelMin: 40,
    levelMax: 40,
    tameMin: 200,
    tameMax: 200,
  },
  {
    name: 'snow wolf',
    area: 'Hiemelia',
    levelMin: 35,
    levelMax: 35,
    tameMin: 175,
    tameMax: 175,
  },
  {
    name: 'beaver',
    area: 'Haven',
    levelMin: 37,
    levelMax: 37,
    tameMin: 148,
    tameMax: 148,
  },
  {
    name: 'spider',
    area: 'Rainforest',
    levelMin: 32,
    levelMax: 36,
    tameMin: 128,
    tameMax: 144,
  },
  {
    name: 'giant pucca bat',
    area: 'Rainforest',
    levelMin: 29,
    levelMax: 36,
    tameMin: 116,
    tameMax: 144,
  },
  {
    name: 'giant elephant',
    area: 'Rainforest',
    levelMin: 29,
    levelMax: 36,
    tameMin: 116,
    tameMax: 144,
  },
  {
    name: 'silverback gorilla',
    area: 'Rainforest',
    levelMin: 29,
    levelMax: 36,
    tameMin: 116,
    tameMax: 144,
  },
  {
    name: 'giant fire ant',
    area: 'Rainforest',
    levelMin: 29,
    levelMax: 36,
    tameMin: 116,
    tameMax: 144,
  },
  {
    name: 'hippo',
    area: 'Rainforest',
    levelMin: 29,
    levelMax: 36,
    tameMin: 116,
    tameMax: 144,
  },
  {
    name: 'muskrat',
    area: 'Rainforest',
    levelMin: 29,
    levelMax: 36,
    tameMin: 116,
    tameMax: 144,
  },
  {
    name: 'water faerie',
    area: 'Rainforest',
    levelMin: 29,
    levelMax: 36,
    tameMin: 116,
    tameMax: 144,
  },
  {
    name: 'shnakra warrior',
    area: 'Rainforest',
    levelMin: 29,
    levelMax: 36,
    tameMin: 116,
    tameMax: 144,
  },
  {
    name: 'chigger',
    area: 'Rainforest',
    levelMin: 29,
    levelMax: 36,
    tameMin: 116,
    tameMax: 144,
  },
  {
    name: 'stalker',
    area: 'DeathSpiral',
    levelMin: 28,
    levelMax: 28,
    tameMin: 140,
    tameMax: 140,
  },
  {
    name: 'leopard',
    area: 'Rainforest',
    levelMin: 32,
    levelMax: 35,
    tameMin: 128,
    tameMax: 140,
  },
  {
    name: 'gorilla',
    area: 'Rainforest',
    levelMin: 32,
    levelMax: 35,
    tameMin: 128,
    tameMax: 140,
  },
  {
    name: 'wild boar',
    area: 'Rainforest',
    levelMin: 32,
    levelMax: 35,
    tameMin: 128,
    tameMax: 140,
  },
  {
    name: 'mongoose',
    area: 'Haven',
    levelMin: 35,
    levelMax: 35,
    tameMin: 140,
    tameMax: 140,
  },
  {
    name: 'anaconda',
    area: 'Rainforest',
    levelMin: 30,
    levelMax: 33,
    tameMin: 120,
    tameMax: 132,
  },
  {
    name: 'vulture',
    area: 'Rainforest',
    levelMin: 29,
    levelMax: 32,
    tameMin: 116,
    tameMax: 128,
  },
  {
    name: 'mongoose',
    area: 'Rainforest',
    levelMin: 28,
    levelMax: 31,
    tameMin: 112,
    tameMax: 124,
  },
  {
    name: 'agouti',
    area: 'Rainforest',
    levelMin: 28,
    levelMax: 31,
    tameMin: 112,
    tameMax: 124,
  },
  {
    name: 'tiger',
    area: 'Rainforest',
    levelMin: 28,
    levelMax: 31,
    tameMin: 112,
    tameMax: 124,
  },
  {
    name: 'sloth',
    area: 'Rainforest',
    levelMin: 28,
    levelMax: 31,
    tameMin: 112,
    tameMax: 124,
  },
  {
    name: 'elephant',
    area: 'Rainforest',
    levelMin: 28,
    levelMax: 31,
    tameMin: 112,
    tameMax: 124,
  },
  {
    name: 'tapir',
    area: 'Rainforest',
    levelMin: 28,
    levelMax: 31,
    tameMin: 112,
    tameMax: 124,
  },
  {
    name: 'muskrat',
    area: 'Rainforest',
    levelMin: 27,
    levelMax: 30,
    tameMin: 108,
    tameMax: 120,
  },
  {
    name: 'water moccassin',
    area: 'Mystic Forest',
    levelMin: 26,
    levelMax: 26,
    tameMin: 104,
    tameMax: 117,
  },
  {
    name: 'monkey',
    area: 'Rainforest',
    levelMin: 25,
    levelMax: 28,
    tameMin: 100,
    tameMax: 112,
  },
  {
    name: 'warthog',
    area: 'Rainforest',
    levelMin: 25,
    levelMax: 28,
    tameMin: 100,
    tameMax: 112,
  },
  {
    name: 'toucan',
    area: 'Rainforest',
    levelMin: 25,
    levelMax: 28,
    tameMin: 100,
    tameMax: 112,
  },
  {
    name: 'wild dog',
    area: 'Rainforest',
    levelMin: 25,
    levelMax: 28,
    tameMin: 100,
    tameMax: 112,
  },
  {
    name: 'beetle',
    area: 'Rainforest',
    levelMin: 21,
    levelMax: 27,
    tameMin: 84,
    tameMax: 108,
  },
  {
    name: 'pigeon',
    area: 'Haven',
    levelMin: 24,
    levelMax: 24,
    tameMin: 96,
    tameMax: 108,
  },
  {
    name: 'wabbit',
    area: 'Mystic Forest',
    levelMin: 26,
    levelMax: 26,
    tameMin: 104,
    tameMax: 104,
  },
  {
    name: 'lizard',
    area: 'Rainforest',
    levelMin: 23,
    levelMax: 26,
    tameMin: 92,
    tameMax: 104,
  },
  {
    name: 'parrot',
    area: 'Rainforest',
    levelMin: 23,
    levelMax: 26,
    tameMin: 92,
    tameMax: 104,
  },
  {
    name: 'bat',
    area: 'Rainforest',
    levelMin: 22,
    levelMax: 25,
    tameMin: 88,
    tameMax: 100,
  },
  {
    name: 'dragonfly',
    area: 'Rainforest',
    levelMin: 22,
    levelMax: 25,
    tameMin: 88,
    tameMax: 100,
  },
  {
    name: 'hamster',
    area: 'Rainforest',
    levelMin: 22,
    levelMax: 25,
    tameMin: 88,
    tameMax: 100,
  },
  {
    name: 'wild boar',
    area: 'Boar Isle',
    levelMin: 20,
    levelMax: 20,
    tameMin: 100,
    tameMax: 100,
  },
  {
    name: 'snow bear',
    area: 'Hiemelia',
    levelMin: 20,
    levelMax: 20,
    tameMin: 80,
    tameMax: 80,
  },
  {
    name: 'badger',
    area: 'Mystic Forest',
    levelMin: 20,
    levelMax: 20,
    tameMin: 80,
    tameMax: 80,
  },
  {
    name: 'marmot',
    area: 'Oz',
    levelMin: 20,
    levelMax: 20,
    tameMin: 80,
    tameMax: 80,
  },
  {
    name: 'giant alligator',
    area: 'Fenris',
    levelMin: 15,
    levelMax: 15,
    tameMin: 75,
    tameMax: 75,
  },
  {
    name: 'baby eagle',
    area: 'DeathSpiral',
    levelMin: 15,
    levelMax: 15,
    tameMin: 75,
    tameMax: 75,
  },
  {
    name: 'bear',
    area: 'Uruk Forest',
    levelMin: 7,
    levelMax: 18,
    tameMin: 28,
    tameMax: 72,
  },
  {
    name: 'lynx',
    area: 'DeathSpiral',
    levelMin: 15,
    levelMax: 15,
    tameMin: 60,
    tameMax: 67,
  },
  {
    name: 'squirrel',
    area: 'Oz',
    levelMin: 15,
    levelMax: 15,
    tameMin: 60,
    tameMax: 67,
  },
  {
    name: 'snow wolf',
    area: 'Hiemelia',
    levelMin: 15,
    levelMax: 15,
    tameMin: 60,
    tameMax: 60,
  },
  {
    name: 'hawk',
    area: 'Uruk Forest',
    levelMin: 6,
    levelMax: 15,
    tameMin: 24,
    tameMax: 60,
  },
  {
    name: 'deer',
    area: 'Uruk Forest',
    levelMin: 5,
    levelMax: 14,
    tameMin: 20,
    tameMax: 56,
  },
  {
    name: 'porcupine',
    area: 'Uruk Forest',
    levelMin: 5,
    levelMax: 14,
    tameMin: 20,
    tameMax: 56,
  },
  {
    name: 'owl',
    area: 'Uruk Forest',
    levelMin: 5,
    levelMax: 13,
    tameMin: 20,
    tameMax: 52,
  },
  {
    name: 'wolf',
    area: 'Uruk Forest',
    levelMin: 5,
    levelMax: 13,
    tameMin: 20,
    tameMax: 52,
  },
  {
    name: 'raccoon',
    area: 'Uruk Forest',
    levelMin: 4,
    levelMax: 12,
    tameMin: 16,
    tameMax: 48,
  },
  {
    name: 'mountain lion',
    area: 'Mystic Forest',
    levelMin: 10,
    levelMax: 10,
    tameMin: 40,
    tameMax: 45,
  },
  {
    name: 'fox',
    area: 'Uruk Forest',
    levelMin: 4,
    levelMax: 11,
    tameMin: 16,
    tameMax: 44,
  },
  {
    name: 'squirrel',
    area: 'Uruk Forest',
    levelMin: 4,
    levelMax: 11,
    tameMin: 16,
    tameMax: 44,
  },
  {
    name: 'bobcat',
    area: 'Mystic Forest',
    levelMin: 8,
    levelMax: 8,
    tameMin: 32,
    tameMax: 36,
  },
  {
    name: 'baby dragon',
    area: 'Cabeiri',
    levelMin: 6,
    levelMax: 6,
    tameMin: 35,
    tameMax: 35,
  },
  {
    name: 'tiger',
    area: 'Cabeiri',
    levelMin: 6,
    levelMax: 6,
    tameMin: 25,
    tameMax: 25,
  },
  {
    name: 'squirrel',
    area: 'Cabeiri',
    levelMin: 3,
    levelMax: 3,
    tameMin: 12,
    tameMax: 13,
  },
  {
    name: 'squirrel',
    area: 'Clouds',
    levelMin: 15,
    levelMax: 15,
    tameMin: 1,
    tameMax: 1,
  },
  {
    name: 'deer',
    area: 'Forest of Deception',
    levelMin: 1,
    levelMax: 1,
    tameMin: 1,
    tameMax: 1,
  },
];
